<template>
  <div class="app-container" v-if="form">
    <el-card>
      <div class="back-box">
        <div @click="handleBack"><img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <!-- 待付款--倒计时 -->
      <template v-if="form.state==1">
        <div class="time-title">等待买家付款</div>
        <div class="time-box">
          剩余支付时长：<el-statistic value-style="color:#F41313;" :value="deadline" format="DD天HH:mm:ss" time-indices></el-statistic>
        </div>
      </template>
      <div class="tab-box">
        <span :class="{'active': tabType === 1}" @click="tabType = 1">基础信息</span>
        <span :class="{'active': tabType === 2}" @click="tabType = 2">物流信息</span>
        <span :class="{'active': tabType === 3}" @click="tabType = 3">订单详情</span>
        <span :class="{'active': tabType === 4}" @click="tabType = 4">分润信息</span>
        <span :class="{'active': tabType === 5}" @click="tabType = 5">操作记录</span>
      </div>
      <template v-if="tabType==1">
        <div class="title-box"><span class="txt1">基础信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="订单编码">{{form.orderNum}}</el-descriptions-item>
          <el-descriptions-item label="随货同行单抬头">{{form.customerIdcard}}</el-descriptions-item>
          <el-descriptions-item label="订单来源">{{form.orderSource}}</el-descriptions-item>
          <el-descriptions-item label="发货方式">{{form.receiptType===20?'到店自提':'快递发货'}}</el-descriptions-item>
          <el-descriptions-item label="快递方式" v-if="form.receiptType===10">{{form.deliveryOptionsName}}</el-descriptions-item>
          <el-descriptions-item label="订单状态">{{form.state === 0?'已取消':(form.state === 1?'待付款':(form.state === 2?'待发货':(form.state === 3?'待收货':(form.state === 4?'已完成':'已失效'))))}}</el-descriptions-item>
          <el-descriptions-item label="下单时间">{{form.createdTime}}</el-descriptions-item>
          <el-descriptions-item label="付款时间">{{form.payTime}}</el-descriptions-item>
          <el-descriptions-item label="取消时间" v-if="form.state === 0">{{form.finishTime}}</el-descriptions-item>
          <el-descriptions-item label="通商云单号">{{form.tongShangYunOrderNum}}</el-descriptions-item>
        </el-descriptions>
        <div class="title-box"><span class="txt1">下单人信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="下单人">{{form.custName}}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{form.custPho}}</el-descriptions-item>
          <el-descriptions-item label="所属区域">{{form.custAddrProvinceCodeName}}{{form.custAddrCityCodeName}}{{form.custAddrAreaCodeName}}</el-descriptions-item>
        </el-descriptions>
        <div class="title-box"><span class="txt1">下单人从属关系</span></div>
        <el-descriptions :column="1">
          <el-descriptions-item label="技术线" v-if='form.techThree || form.techTwo || form.techOne'>
            <div class="fr1-body">
              <span class="blueColor">{{custTechLine}}</span>
            </div>
          </el-descriptions-item>

          <el-descriptions-item label="业务线">
            <div class="fr1-body">
              <span class="blueColor">{{custBusinessLine}}</span>
            </div>
          </el-descriptions-item>
          <el-descriptions-item v-if='form.nameCity' label="城市公司">{{form.nameCity}}</el-descriptions-item>
        </el-descriptions>
        <div class="title-box"><span class="txt1">支付信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="商品总价">{{form.payTotalMoney}}</el-descriptions-item>
          <el-descriptions-item :label="'折扣立减' + (form.buyRatio? '(享体验班账户折扣:'+form.buyRatio+'折)':'')+'金额'">{{form.payDiscountMoney}}</el-descriptions-item>
          <el-descriptions-item label="运费">￥{{form.freight}}</el-descriptions-item>
          <!-- <el-descriptions-item label="凑单优惠">{{form.payDiscountMoney}}</el-descriptions-item> -->
          <el-descriptions-item label="实付金额">{{form.allPayMoney}}</el-descriptions-item>
        </el-descriptions>
        <el-table style="width: 100%" :data="form.payTypeList">
          <el-table-column prop="name" label="支付方式" align="center"></el-table-column>
          <el-table-column prop="money" label="支付金额" align="center"> </el-table-column>
        </el-table>

        <!-- REQ-2026-826259 商城活动规则：活动支付模式、实际支付构成、命中规则、活动标签、赠送结果 -->
        <div class="title-box"><span class="txt1">活动信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="活动支付模式">{{activityModeName}}</el-descriptions-item>
          <el-descriptions-item label="支付阶段">{{form.payStageName || '-'}}</el-descriptions-item>
          <el-descriptions-item label="是否活动商品订单">{{form.activityRewardLoadFailed ? '暂不可用' : (hasActivityRewards ? '是' : '否')}}</el-descriptions-item>
          <el-descriptions-item label="是否含只支持现金的商品">{{form.isCashOnlyGoods?'是':'否'}}</el-descriptions-item>
          <el-descriptions-item label="必付现金">{{form.requiredCashAmount === null || form.requiredCashAmount === undefined ? '-' : form.requiredCashAmount}}</el-descriptions-item>
          <el-descriptions-item label="账户扣款">{{form.accountPayAmount === null || form.accountPayAmount === undefined ? '-' : form.accountPayAmount}}</el-descriptions-item>
          <el-descriptions-item label="现金补差">{{form.cashTopUpAmount === null || form.cashTopUpAmount === undefined ? '-' : form.cashTopUpAmount}}</el-descriptions-item>
          <el-descriptions-item label="实际支付构成" :span="2">{{form.payCompositionText || '-'}}</el-descriptions-item>
          <el-descriptions-item label="命中的活动规则" :span="3">
            <template v-if="activityRuleIds.length">规则ID：{{activityRuleIds.join('、')}}</template>
            <span v-else>{{activityRows.length ? '已登记活动赠送' : (form.activityRewardLoadFailed ? '暂不可用' : '未命中任何规则')}}</span>
          </el-descriptions-item>
          <el-descriptions-item label="活动标签" :span="3">
            <template v-if="activityTags.length">
              <el-tag v-for="(tag,index) in activityTags" :key="index"
                      size="mini" type="success" class="activity-tag">{{tag}}</el-tag>
            </template>
            <span v-else>无活动标签</span>
          </el-descriptions-item>
          <el-descriptions-item label="赠送结果" :span="3">{{activityResultText}}</el-descriptions-item>
        </el-descriptions>

        <!-- 订单附件 -->
        <div class="title-box" v-if="attachmentList && attachmentList.length > 0">
          <span class="txt1">订单附件</span>
        </div>
        <div class="attachment-box" v-if="attachmentList && attachmentList.length > 0">
          <el-image
            v-for="(url, index) in attachmentList"
            :key="index"
            :src="url"
            :preview-src-list="attachmentList"
            fit="cover"
            class="attachment-img"
          >
          </el-image>
        </div>
      </template>
      <template v-else-if="tabType === 2">
        <div class="title-box"><span class="txt1">收货信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="收货人姓名">{{form.name}}</el-descriptions-item>
          <el-descriptions-item label="收货人联系方式">{{form.phone}}</el-descriptions-item>
          <el-descriptions-item label="联系人地址">{{form.addrProvince}}{{form.addrCity}}{{form.addrArea}}{{form.addrDetail}}</el-descriptions-item>
        </el-descriptions>
     
        <div class="title-box"><span class="txt1">物流信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="发货时间">{{form.sendTime}}</el-descriptions-item>
        </el-descriptions>
        <el-table :data="form.logisticsNumber" style="width: 100%">
          <el-table-column prop="lable" label="包裹" align="center" key="1"></el-table-column>
          <el-table-column prop="num" label="快递编号" align="center" key="2"> </el-table-column>
          <el-table-column label="操作" align="center" width="230" key="3">
            <template slot-scope="{ row }">
              <el-button type="text" @click="lookLogistics(row)">查看物流</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="title-box"><span class="txt1">发货信息</span></div>
        <el-table :data="goodsList" style="width: 100%" fit>
          <el-table-column prop="name" label="商品" align="center" key="4"></el-table-column>
          <!-- REQ-2026-234328：只保留这一列。旧的「规格」列（row.spec）与本列同维度，
               并排显示会给出两个互相矛盾的值（实测两列都有值的订单 0 条一致），已删。
               规格取订单快照 snap_spec，为空回落 sys_goods.spec。 -->
          <el-table-column label="产品规格" align="center" key="5-1">
            <template slot-scope="{row}">
              {{row.productSpec || row.spec || '无规格值'}}
            </template>
          </el-table-column>
          <el-table-column prop="jushuitanCode" label="聚水潭规格编码" align="center" key="6"></el-table-column>
          <el-table-column prop="combineCount" label="下单数量（件）" align="center" key="7"></el-table-column>
          <el-table-column label="是否为预售" align="center" key="8">
            <template slot-scope="{ row }">
              {{row.presell?'是':'否'}}
            </template>
          </el-table-column>
          <el-table-column prop="presellTime" label="预售商品距离预计发货时间还剩（天）" align="center" key="9"> </el-table-column>
          <el-table-column prop="sendNum" label="已发数量（件）" align="center" key="10"> </el-table-column>
          <el-table-column prop="daiNum" label="待发数量（件）" align="center" key="11"> </el-table-column>
        </el-table>
      </template>
      <template v-else-if="tabType === 3">
        <div class="title-box"><span class="txt1">基础信息</span></div>
        <el-descriptions v-if="form.receiptType===10">
          <el-descriptions-item label="随货同行单">{{form.customerIdcard}}</el-descriptions-item>
          <el-descriptions-item label="收货人姓名">{{form.name}}</el-descriptions-item>
          <el-descriptions-item label="收货人联系方式">{{form.phone}}</el-descriptions-item>
          <el-descriptions-item label="联系人地址">{{form.addrProvince}}{{form.addrCity}}{{form.addrArea}}{{form.addrDetail}}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions v-if="form.receiptType===20">
          <el-descriptions-item label="随货同行单">{{form.customerIdcard}}</el-descriptions-item>
          <el-descriptions-item label="发货方式">自提</el-descriptions-item>
          <el-descriptions-item label="自提地址">{{form.addrDetail}}</el-descriptions-item>
          <el-descriptions-item label="自提时间">{{formatDate(form.pickupTime) }}</el-descriptions-item>
        </el-descriptions>
        <div class="title-box" v-if="form.writeoffTime"><span class="txt1">自提产品核销信息</span></div>
        <el-descriptions v-if="form.writeoffTime">
          <el-descriptions-item label="核销时间">{{form.writeoffTime }}</el-descriptions-item>
          <el-descriptions-item label="核销人信息">{{form.writeoffUserRealName}}({{ form.writeoffUserLevelName }}){{ form.writeoffUserMobile }}</el-descriptions-item>
        </el-descriptions>
        <div class="title-box"><span class="txt1">商品列表</span></div>
        <el-descriptions>
          <el-descriptions-item label="商品总价">{{form.payTotalMoney}}</el-descriptions-item>
          <el-descriptions-item label="折扣立减金额">{{form.payDiscountMoney}}</el-descriptions-item>
          <el-descriptions-item label="运费">{{form.freight}}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions>
          <el-descriptions-item label="商品列表"></el-descriptions-item>
        </el-descriptions>
        <el-table :data="noSendList" style="width: 100%">
          <!-- <el-table-column label="序号" align="center" type="index" key="12">
            <template slot-scope="scope">
              {{ scope.$index+1 }}
            </template>
          </el-table-column> -->
          <el-table-column label="序号" type="index" width="50" key="12"></el-table-column>
          <el-table-column prop="name" label="商品名称" align="center" key="13"></el-table-column>
          <el-table-column label="产品规格" align="center" key="14-1">
            <template slot-scope="{row}">
              {{row.productSpec || row.spec || '无规格值'}}
            </template>
          </el-table-column>
          <el-table-column prop="jushuitanCode" label="聚水潭规格编码" align="center" key="15"></el-table-column>
          <el-table-column prop="skuRetailPrice" label="市场价" align="center" key="16"> </el-table-column>
          <el-table-column prop="combineCount" label="数量" align="center" key="17"> </el-table-column>
          <el-table-column prop="tableMoney" label="小计" align="center" key="18">
            <template slot-scope="{row}">
              {{ form.type === 1?row.tableMoney: row.realPrice }}
            </template>
          </el-table-column>
          <el-table-column prop="actualPrice" label="实际支付价格" align="center" key="19" v-if="form.type === 1"> </el-table-column>
        </el-table>
        <template v-if="giftDisplayList.length > 0 || pendingGiftPreview.message">
          <el-descriptions class="mt10">
            <el-descriptions-item label="赠品列表"></el-descriptions-item>
          </el-descriptions>
          <p v-if="pendingGiftPreview.rows.length" class="pending-gift-note">待发放实物赠品将在订单支付成功后发放。</p>
          <p v-if="pendingGiftPreview.message" class="pending-gift-warning">{{pendingGiftPreview.message}}</p>
          <el-table v-if="giftDisplayList.length" :data="giftDisplayList" style="width: 100%" data-order-gifts>
            <!-- <el-table-column label="序号" align="center" type="index" key="19">
            <template slot-scope="scope">
              {{ scope.$index+1 }}
            </template>
          </el-table-column> -->
            <el-table-column label="序号" type="index" width="50" key="19"></el-table-column>
            <el-table-column prop="name" label="商品名称" align="center" key="20"></el-table-column>
            <el-table-column label="产品规格" align="center" key="21-1">
              <template slot-scope="{row}">
                {{row.productSpec || row.spec || '无规格值'}}
              </template>
            </el-table-column>
            <el-table-column prop="jushuitanCode" label="聚水潭规格编码" align="center" key="22"></el-table-column>
            <!-- <el-table-column prop="" label="市场价" align="center" key="23">
            <template slot-scope="{row}">
              0
            </template>
          </el-table-column> -->
            <el-table-column prop="combineCount" label="数量" align="center" key="24"> </el-table-column>
            <el-table-column v-if="pendingGiftPreview.rows.length" label="赠品状态" align="center" key="gift-status">
              <template slot-scope="{row}">{{row.pendingPreview ? '待发放' : '已有赠品明细'}}</template>
            </el-table-column>
            <!-- <el-table-column prop="" label="小计" align="center" key="25">
            <template slot-scope="{row}">
              0
            </template>
          </el-table-column> -->
          </el-table>
        </template>
        <order-activity-rewards :records="form.activityRewardLogList" :failed="form.activityRewardLoadFailed" />
        <el-descriptions>
          <el-descriptions-item label="商品总价">￥{{form.payTotalMoney}}</el-descriptions-item>
          <el-descriptions-item label="邮费">￥{{form.freight}}</el-descriptions-item>
          <el-descriptions-item label="折扣立减金额">￥{{form.payDiscountMoney || 0}}</el-descriptions-item>
          <el-descriptions-item label="实付款"><span class="redColor">￥{{form.allPayMoney}}</span></el-descriptions-item>
          <el-descriptions-item :label="getGoodsTypeLabel(form.goodsType) +'支付'" v-if="form.orderPayType === 2 ||  form.orderPayType === 5 ||form.orderPayType === 6">
            <span class="redColor">￥{{balanceAmount || 0}}</span></el-descriptions-item>
          <el-descriptions-item label="微信支付" v-if="form.rmbPayType===1"><span class="redColor">￥{{form.rmbMoney || 0}}</span></el-descriptions-item>
          <el-descriptions-item label="支付宝支付" v-if="form.rmbPayType===2"><span class="redColor">￥{{form.rmbMoney || 0}}</span></el-descriptions-item>
          <el-descriptions-item label="银行卡支付" v-if="form.rmbPayType===3"><span class="redColor">￥{{form.rmbMoney || 0}}</span></el-descriptions-item>
        </el-descriptions>
      </template>
      <template v-else-if="tabType === 4">
        <div class="title-box"><span class="txt1">分润信息</span></div>
        <el-table :data="form.customerOrderGoodsList" style="width: 100%">
          <el-table-column label="分润对象" align="center" type="index" key="26">
            <template slot-scope="scope">
              {{ scope.$index+1 }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="分润比例（基数为订单实收金额）" align="center" key="27"></el-table-column>
          <el-table-column prop="combineId" label="实收佣金（元）" align="center" key="28"></el-table-column>
          <el-table-column prop="tableMoney" label="小计" align="center" key="29"> </el-table-column>
        </el-table>
      </template>
      <template v-else-if="tabType === 5">
        <div class="title-box"><span class="txt1">操作记录</span></div>
        <el-table :data="logList" style="width: 100%">
          <el-table-column prop="createdTime" label="操作时间" align="center" key="30"></el-table-column>
          <el-table-column prop="createdBy" label="操作人" align="center" key="31"></el-table-column>
          <el-table-column prop="title" label="操作内容" align="center" key="32"> </el-table-column>
          <el-table-column prop="remarks" label="备注" align="center" key="33"> </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :pageNo.sync="logQuery.page" :pageSize.sync="logQuery.pageSize" @pagination="getLogList" />
      </template>
    </el-card>
    <logistics-details-vue ref="logisticsDetailsVue" />
  </div>
</template>
<script>
import goodsOrderApi from '@/api/order/goodsOrder'
import OrderActivityRewards from './activityRewards.vue'
import { orderActivityRewards } from '@/utils/orderActivityRewards'
import { pendingOrderGifts } from '@/utils/pendingOrderGifts'
import sysStepLogApi from '@/api/log/sysStepLog'
import { Subtr, accMul, formatDate } from '@/utils/index'
import logisticsDetailsVue from '@/views/common/logisticsDetails.vue';
import sysDataconstantApi from '@/api/config/sysDataconstant' 
import Pagination from '@/components/Pagination'
export default {
  props: ['rowItem'],
  components: { logisticsDetailsVue, Pagination, OrderActivityRewards },
  data() {
    return {
      activeName: 2,
      tabType: 1,  //1基础信息 2 物流信息 3
      tableData: [],
      form: '',
      logistics: "",
      goodsList: [],
      sendList: [],
      noSendList: [],
      goodsListLoaded: false,
      goodsListLoadFailed: false,
      deadline: '',
      logQuery: {
        page: 1,
        pageSize: 10
      },
      logList: [],
      total: 0
    };
  },
  created() {
    this.activeName = +this.rowItem.activeName
    this.getDetails();
    this.getLogList()
  },
  computed: {
    pendingGiftPreview() { return pendingOrderGifts(this.form, this.sendList, this.goodsListLoaded, this.goodsListLoadFailed) },
    giftDisplayList() { return this.sendList.concat(this.pendingGiftPreview.rows) },
    activityRows() { return orderActivityRewards(this.form.activityRewardLogList) },
    activityModeName() { return this.form.activityPayModeName || [...new Set(this.activityRows.map(row => row.mode))].join('、') || '无' },
    hasActivityRewards() { return Boolean(this.form.isActivityGoods || this.activityRows.length) },
    activityRuleIds() { return this.form.activityRuleIds || [...new Set(this.activityRows.map(row => row.conditionId).filter(id => Number(id) > 0))] },
    activityTags() { return this.form.activityTagList || [...new Set(this.activityRows.map(row => `${row.activityName}：${row.ruleText}`))] },
    activityResultText() {
      if (this.form.activityRewardLoadFailed) return '活动赠送记录读取失败，请重新打开订单详情'
      return this.form.rewardResultText || this.activityRows.map(row => `${row.activityName}（${row.status}）：${row.rewardText}`).join('；') || '无赠送'
    },
    custBusinessLine() {
      const form = this.form
      const arr = []
      if (form.custOne) arr.push(form.nameCustOne + '【营销总监】')
      if (form.custTwo) arr.push(form.nameCustTwo + '【营销经理】')
      if (form.custThree) arr.push(form.nameCustThree + '【大区经理】')
      if (form.custFour) arr.push(form.nameCustFour + '【地区经理】')
      if (form.custFive) arr.push(form.nameCustFive + '【县区经理】')
      const self = form.custName + '【' + this.getCLevelLabel(form.custCLevel) + '】'
      return arr.length ? self + ' - ' + arr.reverse().join(' - ') : self
    },
    custTechLine() {
      const form = this.form
      const arr = []
      if (form.techOne) arr.push(form.nameTechOne + '【技术总监】')
      if (form.techTwo) arr.push(form.nameTechTwo + '【技术经理】')
      if (form.techThree) arr.push(form.nameTechThree + '【技术老师】')
      const self = form.custName + '【' + this.getCLevelLabel(form.custCLevel) + '】'
      return arr.length ? self + ' - ' + arr.reverse().join(' - ') : self
    },
    balanceAmount() {
      let price = 0
      let { allPayMoney, rmbMoney, orderPayType } = this.form;
      if (orderPayType === 2 || orderPayType === 5 || orderPayType === 6) {
        price = Subtr(allPayMoney, rmbMoney)
      }
      price = +price < 0 ? 0 : price
      return price
    },
    // 附件URL列表
    attachmentList() {
      if (this.form && this.form.attachmentUrls) {
        return this.form.attachmentUrls.split(',').filter(url => url.trim());
      }
      return [];
    }
  },
  methods: {
    formatDate,
    getCLevelLabel(cLevel, customerType) {
      const map = { 1: '总监', 2: '营销经理', 3: '大区经理', 4: '地区经理', 5: '县区经理', 6: '研修班', 7: '体验班', 8: '普通人员' }
      if (cLevel && map[cLevel]) return map[cLevel]
      const tMap = { 1: '总监经理', 2: '业务员', 3: '加盟商' }
      return tMap[customerType] || ''
    },
    getGoodsTypeLabel(type) {
      const goodsTypeMap = {
        1: '余额账户',
        2: '零售价',
        3: '学费',
        4: '积分'
      }
      return goodsTypeMap[type] || '余额支付'
    },
    getBisicsInfo() {
      sysDataconstantApi.fetchBatchCode({ code: 'order_cancel_time' }).then(({ data }) => {
        let { createdTime } = this.form
        let time = +data.list[0].content
        this.deadline = new Date(createdTime).getTime() + time * 60 * 1000
      })
    },
    getLogList() {
      let { page, pageSize } = this.logQuery;
      sysStepLogApi.fetchList({ type: 2, foreignId: this.rowItem.id, page, pageSize }).then(({ data }) => {
        this.logList = data.list;
        this.total = data.total;
      })
    },
    getDetails() {
      console.log(this.rowItem)
      goodsOrderApi.getGoodsDetail(this.rowItem.id).then(({ data }) => {
        data.logisticsNumber = data.logisticsNumber ? data.logisticsNumber.split(",") : [];
        if (data.logisticsNumber && data.logisticsNumber.length > 0) {
          data.logisticsNumber = this.arrayToObject(data.logisticsNumber);
        }
        data.payTypeList = [];
        let obj = {
          name: data.orderPayType === 1 ? '零售价' : (data.orderPayType === 2 ? '余额' : (data.orderPayType === 3 ? '积分' : (data.orderPayType === 4 ? '赠送' : (data.orderPayType === 5 ? '在线' : '组合')))),
          money: (data.orderPayType != 5 && data.orderPayType != 6) ? data.allPayMoney : (data.orderPayType == 5 ? data.rmbMoney : this.getGoodsTypeLabel(this.rowItem.goodsType) + ':' + data.allPayMoney + '在线:' + data.rmbMoney)
        }
        data.payTypeList.push(obj);
        if (data.rmbMoney) {
          data.allPayMoney = Subtr(data.allPayMoney, -data.rmbMoney)
        }
        this.form = data;
        this.getLogisticsNumber(data.id);
        this.getBisicsInfo()
      })
    },
    arrayToObject(arr) {
      return arr.map((el, i) => ({
        lable: "包裹" + (i + 1),
        num: el,
      }));
    },
    // 物流信息
    // getLogisticsNumber(logisticsNumber) {
    //   goodsOrderApi.getGoodsDetail({ logisticsNumber }).then(({ data }) => {
    //     this.logistics = data;
    //   })
    // },
    // 查询发货信息相关商品信息
    getLogisticsNumber(id) {
      this.goodsListLoaded = false;
      this.goodsListLoadFailed = false;
      goodsOrderApi.getGoodsList({ orderId: id, pageSize: 1000 }).then(res => {
        let { list } = res.data, sendList = [], noSendList = [];
        if (list.length > 0) {
          list.forEach(it => {
            it.daiNum = Subtr(it.combineCount, it.sendNum);
            let price = it.skuRetailPrice || it.goodsPrice
            it.tableMoney = accMul(price, it.combineCount);
            // 添加实际支付价格计算
            it.actualPrice = accMul(it.tableMoney, this.form.buyRatio || 1);
            if (it.isSend) {
              sendList.push(it);
            } else {
              noSendList.push(it);
            }
          })
        }
        this.goodsList = list;
        this.sendList = sendList;
        this.noSendList = noSendList;
        this.goodsListLoaded = true;
      }).catch(() => {
        this.goodsListLoadFailed = true;
      })
    },
    lookLogistics(row) {
      let { phone } = this.form;
      let str = phone ? `:${phone.trim().slice(-4)}` : ''
      this.$refs.logisticsDetailsVue.handleShow(row.num + str)
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    }
  },
};
</script>
<style lang="scss" scoped>
.pending-gift-note { color: #606266; font-size: 14px; }
.pending-gift-warning { color: #c45656; font-size: 14px; }
.custom {
  font-size: 14px;
  color: #2e2f3e;
  padding: 20px;
  margin: 10px 0;
  &.bg {
    // border-bottom: 1px solid #CCE2D1
    background-color: #eff8fd;
  }
}
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-right: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
.title-cont {
  padding: 10px 20px;
  .fr3 {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .fr3-body {
      width: 33.33%;
      font-size: 14px;
      color: #2e2f3e;
      line-height: 30px;
    }
  }
  .fr1 {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .fr1-body {
      width: 100%;
      font-size: 14px;
      color: #2e2f3e;
      line-height: 30px;
    }
  }
}
.fr1-body {
  width: 100%;
  font-size: 14px;
  color: #2e2f3e;
}
.blueColor {
  color: #1596cd !important;
}
.redColor {
  color: #e73f3f !important;
}
.attachment-box {
  padding: 10px 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  .attachment-img {
    width: 100px;
    height: 100px;
    border-radius: 4px;
    cursor: pointer;
    border: 1px solid #dcdfe6;
  }
}
.time-title {
  font-size: 30px;
  font-weight: 700;
  padding-bottom: 10px;
  color: #000000;
}
.time-box {
  display: flex;
  align-items: center;
  font-size: 20px;
  color: #f41313;
  margin-bottom: 20px;
  .el-statistic {
    width: 140px !important;
  }
}
/* REQ-2026-826259 订单活动标签 */
.activity-tag {
  margin: 0 4px 4px 0;
}
</style>
